import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box,
  FormControl, InputLabel, Select, MenuItem, Typography
} from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";

/**
 * Configuracao do gatilho de recuperacao de venda.
 *
 * Duas escolhas: qual evento do gateway comeca este fluxo e por qual conexao
 * o cliente sera respondido. A conexao mora aqui, no proprio fluxo, porque o
 * evento traz o telefone do comprador mas nao diz por qual numero falar.
 */

const EVENTOS = [
  { chave: "carrinho_abandonado", nome: "Carrinho abandonado" },
  { chave: "pix_gerado", nome: "Pix gerado (não pago)" },
  { chave: "boleto_gerado", nome: "Boleto gerado (não pago)" },
  { chave: "pagamento_atrasado", nome: "Pagamento atrasado" },
  { chave: "compra_aprovada", nome: "Compra aprovada" },
  { chave: "compra_recusada", nome: "Compra recusada" },
  { chave: "reembolso", nome: "Reembolso ou estorno" },
  { chave: "codigo_rastreio", nome: "Código de rastreio" }
];

const VARIAVEIS = [
  "nome", "primeiro_nome", "telefone", "email", "documento",
  "produto", "plano", "valor", "parcelas",
  "pix_copia_cola", "boleto_linha", "boleto_url", "checkout_url",
  "rastreio", "transportadora", "endereco", "cidade", "estado", "pedido",
  "tipo_evento"
];

const FlowBuilderGatilhoGatewayModal = ({ open, onSave, data, close }) => {
  const [gateway, setGateway] = useState("braip");
  const [evento, setEvento] = useState("");
  const [whatsappId, setWhatsappId] = useState("");
  const [conexoes, setConexoes] = useState([]);

  useEffect(() => {
    if (!open) return;
    api
      .get("/whatsapp", { params: { session: 0 } })
      .then(({ data: lista }) => setConexoes(Array.isArray(lista) ? lista : []))
      .catch(err => toastError(err));
  }, [open]);

  useEffect(() => {
    if (open === "edit" && data) {
      const d = data.data || data;
      setGateway(d.gateway || "braip");
      setEvento(d.evento || "");
      setWhatsappId(d.whatsappId || "");
    }
    if (open === "create") {
      setGateway("braip");
      setEvento("");
      setWhatsappId("");
    }
  }, [open, data]);

  return (
    <Dialog open={!!open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>Recuperação de venda</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          Este bloco começa o fluxo quando o gateway avisa que algo aconteceu.
          Ligue a integração em Integrações e aponte a URL de webhook no painel
          do gateway.
        </Typography>

        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 16 }}>
          <InputLabel>Gateway</InputLabel>
          <Select label="Gateway" value={gateway} onChange={e => { const v = e.target.value; setGateway(v); }}>
            <MenuItem value="braip">Braip</MenuItem>
            <MenuItem value="payt">Payt</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 16 }}>
          <InputLabel>Quando acontecer</InputLabel>
          <Select label="Quando acontecer" value={evento} onChange={e => { const v = e.target.value; setEvento(v); }}>
            {EVENTOS.map(ev => (
              <MenuItem key={ev.chave} value={ev.chave}>{ev.nome}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Responder pela conexão</InputLabel>
          <Select
            label="Responder pela conexão"
            value={whatsappId}
            onChange={e => { const v = e.target.value; setWhatsappId(v); }}
          >
            {conexoes.map(c => (
              <MenuItem key={c.id} value={c.id}>
                {c.name} {c.channel && c.channel !== "whatsapp" ? `(${c.channel})` : ""}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box style={{ marginTop: 20, background: "#f8fafc", borderRadius: 8, padding: 12 }}>
          <Typography variant="caption" style={{ fontWeight: 700, display: "block", marginBottom: 6 }}>
            Variáveis disponíveis nos blocos seguintes
          </Typography>
          <Typography variant="caption" style={{ color: "#475569", lineHeight: 1.7 }}>
            {VARIAVEIS.map(v => `{{${v}}}`).join("  ")}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!evento || !whatsappId}
          onClick={() => onSave({ gateway, evento, whatsappId })}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderGatilhoGatewayModal;
